// Build-time inlined per-feature translations. Values are owned by the Translations DB
// table and flow into the feature's locale JSONs via /sync-translations; code adds keys
// only. Locale detection mirrors the legacy path (language cookie); an empty value falls
// through to Estonian and finally to the key name.
export type FeatureLocale = 'et' | 'en' | 'ru';

function detectLocale(): FeatureLocale {
    const match = document.cookie.match(/(?:^| )language=([^;]+)/);
    const cookie = match ? decodeURIComponent(match[1]) : '';
    if (cookie === 'en' || cookie === 'ru' || cookie === 'et') return cookie;
    return 'et';
}

export function createFeatureI18n<T extends Record<string, string>>(dict: Record<FeatureLocale, T>) {
    const locale = detectLocale();
    const t = (key: keyof T): string => dict[locale][key] || dict.et[key] || String(key);
    const messages = dict[locale];
    return {t, messages, locale};
}
